import { To, History } from 'history';
import { matchPath } from 'react-router-dom';
import { ROUTES } from '../Base.constants';
import useCheckArticleAccessStatus from './articles/useCheckArticleAccessStatus';

const matchArticleParam = (pathname: string = '') => matchPath(ROUTES.article(':id'), pathname);

export default (history: History): History => {
  const checkArticleAccessStatus = useCheckArticleAccessStatus();

  const customPush = (to: To, state?: any) => {
    const articleMatch = typeof to === 'string' ? matchArticleParam(to) : matchArticleParam(to.pathname);
    if (!articleMatch) {
      history.push(to, state);
      return;
    }
    if (articleMatch.params.id) {
      checkArticleAccessStatus(Number(articleMatch.params.id), () =>
        history.push(to, { ...state, checkQuota: false, checkLoanWaiver: false })
      );
    }
  };

  return { ...history, push: customPush };
};
